// Delegation also supports footer re-renders in the Shopify theme editor.
(function () {
  if (window.wftFooterInitialized) return;
  window.wftFooterInitialized = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-footer-cookie-preferences]');
    if (!button) return;
    var status = button.closest('.footer-bottom').querySelector('[data-footer-cookie-status]');
    status.hidden = true;
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      status.hidden = false;
      return;
    }
    button.disabled = true;
    Promise.resolve().then(function () {
      return window.privacyBanner.showPreferences();
    }).catch(function () {
      status.hidden = false;
    }).finally(function () { button.disabled = false; });
  });
})();
